export function getUrlParams(url) {
	let params = url.split('?')[1];
	// 将参数部分转换为对象
	let paramsObj = {};
	if (params) {
		let paramsArr = params.split('&');
		for (let i = 0; i < paramsArr.length; i++) {
			let param = paramsArr[i].split('=');
			paramsObj[param[0]] = param[1];
		}
		return paramsObj
	}
}